var React = require('react');

function InfoData (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 24V13H2V22H11V24H0ZM13 24V22H22V13H24V24H13ZM3.9 19.0667L7.83333 14L10.9333 18.2333L15.3333 12.5333L20.2333 19.0667H3.9ZM0 11V0H11V2H2V11H0ZM22 11V2H13V0H24V11H22ZM16.8 9C16.28 9 15.85 8.83 15.51 8.49C15.17 8.15 15 7.72 15 7.2C15 6.68 15.17 6.25 15.51 5.91C15.85 5.57 16.28 5.4 16.8 5.4C17.32 5.4 17.75 5.57 18.09 5.91C18.43 6.25 18.6 6.68 18.6 7.2C18.6 7.72 18.43 8.15 18.09 8.49C17.75 8.83 17.32 9 16.8 9Z","fill":"#212121"}));
}

InfoData.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InfoData;

InfoData.default = InfoData;
